import { useAuthStore } from "../contexts/AuthContext";
import { useAccountDataTableStore } from "../contexts/AccountDataTableContext";
import { useUpdateCubeDataHook } from "../controllers/useUpdateCubeDataHook";
import { useCubeData, useCubeDataDispatch } from "../contexts/CubeDataContext";
import { normalize } from "./makeContexts";
import { getActiveCustomJoins } from "./useCheckCustomJoins";

export function useHandleCubeFetch() {
    const { selectedAccount } = useAuthStore();
    const { liveCubeDataCollection, demoCubeDataCollection, accountCustomJoins } = useCubeData();
    const { availableAccountDataTableSlugs } = useAccountDataTableStore();
    const { updateCubeData } = useUpdateCubeDataHook();
    const cubeDataDispatch = useCubeDataDispatch();
    
    const handleCubeFetch = async ({ dashboard, dataTables, editedDashboard }) => {
        try {
            const tempDashboard = dashboard ? { ...dashboard } : { ...editedDashboard };
            //normalize the dashboard data tables so they are both in the same format
            const tempDataTables = dashboard ? normalize(dashboard?.DashboardDataTables) : { ...dataTables };
            const dataTableList = []
            
            const anchorDataTableSlug = dashboard ? tempDataTables[Object.keys(tempDataTables).find((dataTableId) => tempDataTables[dataTableId]?.anchorDataTable)]?.["SampleDataTable"]?.["slug"] : tempDataTables[Object.keys(tempDataTables).find((dataTableId) => tempDataTables[dataTableId]?.anchorDataTable)]?.slug;

            if (!tempDashboard.useDemoData) {
                Object.keys(tempDataTables).forEach((dataTableId) => {
                    let dataTableSlug = tempDataTables[dataTableId]?.slug || tempDataTables[dataTableId]?.["SampleDataTable"]?.slug;
                    if (availableAccountDataTableSlugs?.[dataTableSlug]) {
                        if (Object.keys(liveCubeDataCollection).length === 0 || (!liveCubeDataCollection?.[anchorDataTableSlug]?.[dataTableSlug] && dataTableSlug !== anchorDataTableSlug) || (dataTableSlug === anchorDataTableSlug && !liveCubeDataCollection?.[anchorDataTableSlug])) {
                            dataTableList.push({
                                name: tempDataTables[dataTableId]?.name || tempDataTables[dataTableId]?.["SampleDataTable"]?.["DataTable"]?.["name"],
                                slug: dataTableSlug,
                                cube: dataTableSlug,
                                fetched: false,
                                anchorDataTable: tempDataTables[dataTableId]?.anchorDataTable,
                            })
                        } else {
                            dataTableList.push({
                                name: tempDataTables[dataTableId]?.name || tempDataTables[dataTableId]?.["SampleDataTable"]?.["DataTable"]?.["name"],
                                slug: dataTableSlug,
                                cube: dataTableSlug,
                                fetched: true,
                                anchorDataTable: tempDataTables[dataTableId]?.anchorDataTable,
                            })
                        }
                    }
                })
            } else {
                Object.keys(tempDataTables).forEach((dataTableId) => {
                    let dataTableSlug = tempDataTables[dataTableId]?.slug || tempDataTables[dataTableId]?.["SampleDataTable"]?.slug;

                    if (Object.keys(demoCubeDataCollection).length === 0 || (!demoCubeDataCollection?.[anchorDataTableSlug]?.[dataTableSlug] && dataTableSlug !== anchorDataTableSlug) || (dataTableSlug === anchorDataTableSlug && !demoCubeDataCollection?.[anchorDataTableSlug])) {
                        dataTableList.push({
                            name: tempDataTables[dataTableId]?.name || tempDataTables[dataTableId]?.["SampleDataTable"]?.["DataTable"]?.["name"],
                            slug: tempDataTables[dataTableId]?.slug || tempDataTables[dataTableId]?.["SampleDataTable"]?.slug,
                            cube: tempDataTables[dataTableId]?.slug || tempDataTables[dataTableId]?.["SampleDataTable"]?.slug,
                            fetched: false,
                            anchorDataTable: tempDataTables[dataTableId]?.anchorDataTable,
                        })
                    } else {
                        dataTableList.push({
                            name: tempDataTables[dataTableId]?.name || tempDataTables[dataTableId]?.["SampleDataTable"]?.["DataTable"]?.["name"],
                            slug: dataTableSlug,
                            cube: dataTableSlug,
                            fetched: true,
                            anchorDataTable: tempDataTables[dataTableId]?.anchorDataTable,
                        })
                    }
                })
            }
            if (dataTableList.length === 0) {
                cubeDataDispatch({
                    type: 'setCurrentCubeAnchorSlug',
                    payload: { anchorTableSlug: anchorDataTableSlug, useDemoData: tempDashboard?.useDemoData }
                });
            }
            const customJoinList = getActiveCustomJoins({
              accountCustomJoins,
              dataCollection: tempDashboard?.useDemoData
                ? demoCubeDataCollection
                : liveCubeDataCollection,
              currentAnchorSlug: anchorDataTableSlug,
            });
            const status = await updateCubeData({ selectedAccount, useDemoData: tempDashboard.useDemoData, dataTableList, customJoinList });
            return status;
        } catch (error) {
            console.error("Error fetching cube data:", error);
        }
    };
    return { handleCubeFetch }
}